module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Events":"Events","Bookings":"Anmeldungen","Categories":"Kategorien","Registration forms":"Anmeldeformulare"}}')
  delete Component.options._Ctor
}
